import { render, staticRenderFns } from "./BaseRadarChart.vue?vue&type=template&id=770c59e7&"
import script from "./BaseRadarChart.vue?vue&type=script&lang=js&"
export * from "./BaseRadarChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports